<woa-modal-page-layout [title]="title()" [footerControlOrientation]="'vertical'">
    @if (orderingContextModel.canChangeStore()) {
        <woa-selection-field class="context-selection"
                             [label]="storeLabel()" [link]="'woa.button.ordering-context.viewCurrentStore'"
                             [value]="orderingContextModel.currentStore()?.collectiveStoreName"
                             (onActivateField)="orderingContextModel.changeStoreOrOrderType(undefined)"
                             (onActivateLink)="orderingContextModel.viewCurrentStore()"></woa-selection-field>
    }
    @if (orderingContextModel.orderType() === OrderType.ORDER_AT_TABLE) {
        <woa-selection-field class="context-selection"
                             [label]="'woa.label.ordering-context.seatedAt'"
                             [value]="orderingContextModel.currentTableNumberLabel()"
                             (onActivateField)="orderingContextModel.changeFulfilmentDetails()"></woa-selection-field>
    } @else if (orderingContextModel.orderType() === OrderType.ORDER_DELIVERY) {
        <woa-selection-field class="context-selection"
                             [label]="'woa.label.ordering-context.deliveringTo'"
                             [link]="orderingContextModel.addressTrusted() ? 'woa.button.ordering-context.changeDeliveryAddress' : undefined"
                             [disabled]="orderingContextModel.addressTrusted()"
                             [value]="confirmedAddress()"
                             [placeholder]="'woa.label.ordering-context.enterDeliveryAddress'"
                             (onActivateField)="orderingContextModel.changeFulfilmentDetails()"
                             (onActivateLink)="orderingContextModel.changeFulfilmentDetails()"></woa-selection-field>
    }
    @if (orderingContextModel.canSelectOrderTime()) {
        <woa-selection-field class="context-selection"
                             [label]="'woa.label.ordering-context.orderTime'"
                             [value]="orderTime() | translate"
                             [placeholder]="'woa.label.ordering-context.selectOrderTime'"
                             [message]="etaLabel()" [showMessageSpinner]="showTimeSpinner()"
                             [translationParams]="{eta: orderModel.orderEta()}"
                             (onActivateField)="orderingContextModel.changeExpectedCompletion()"></woa-selection-field>
    }
    @if (!orderingContextModel.evaluatingExpectedCompletionChange() && orderModel.showOrderTimeAllocationNotice()) {
        <woa-content-message class="context-error" [level]="MessageLevel.ERROR"
                             [text]="orderModel.orderTimeAllocationNotice()"></woa-content-message>
    }
    <woa-button woa-page-footer-control [label]="'woa.button.common.continue'"
                (onActivate)="dismiss()"></woa-button>
    @if (!orderingContextModel.singleOrderType()) {
        <woa-link woa-page-footer-control class="change-order-type"
                  [link]="'woa.heading.ordering-context.changeOrderType'"
                  (onActivate)="orderingContextModel.changeOrderType()"></woa-link>
    }
</woa-modal-page-layout>
